var Backbone = require('backbone'),
    FindAndRedactSearchOptions = require( '../SearchOptions'),
    ZoneFactory = require('./zone/frApiZoneFactory');


/**
 *
 * userProvidedNoteTextXREF:
 * - quick solution -- could also put a property on note model prototypes -- but this is pretty simple
 * - user provided name to JAVA enum
 */


var userProvidedNoteTextXREF = {
    redaction: 'REDACTION_NOTE',
    highlight: 'HIGHLIGHT_NOTE'
};


module.exports = Backbone.Model.extend({

    defaults: {

        term: '', /* Required */

        /* Optional -- one object under frApiGlobal options */
        noteType: userProvidedNoteTextXREF['redaction'], // converted on creation to the JAVA_ONE on load -- REDACTION_NOTE
        zone: null, // frAPIZone ( depends on note type )
        note: null, // not yet implemented
        search: new FindAndRedactSearchOptions() // actually, when implemented this could be diff API model ... TODO: make null and then create from what is provided

    },

    constructor: function( attributes ) {

        // Clone -- we have issues when comparing the global and merging -- since as of now the attributes can be changed -- we never want to be looked at model -- just what would be passed in raw
        var attrs = attributes
            ? JSON.parse( JSON.stringify(attributes)  )
            : {};

        //console.log( JSON.stringify(attrs) );

        /* Note-type */

        if ( !attrs.noteType || Object.keys( userProvidedNoteTextXREF ).indexOf( attrs.noteType.toLowerCase().trim() ) < 0 ) {
            attrs.noteType = this.defaults.noteType;
        }
        else {
            attrs.noteType = userProvidedNoteTextXREF[ attrs.noteType.toLowerCase().trim() ];
        }

        /* Zone */
        if ( attrs.zone ) {
            var ZoneApiModel = ZoneFactory( attrs.noteType );
            attrs.zone = new ZoneApiModel( attrs.zone );

        }

        /* Search */
        if ( attrs.search ) {
            attrs.search = new FindAndRedactSearchOptions( attrs.search );
        }

        Backbone.Model.call( this, attrs );

    },

    /**
     * Now only doing the term - it is required.
     * All else currently fails silently -- warnings, errors are printed and displayed.
     */
    validate: function( attrs ) {

        if ( !attrs ) {
            return 'Search not provided';
        }

        if ( !attrs.term ) {
            return 'No term provided';
        }

        // Could validate others and put that in fn .... now not necessary

    }


});





/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/api/frApiSearchModel.js
 ** module id = 676
 ** module chunks = 0
 **/